export enum IND_PRES {
    "NAO_SE_APLICA" = "0",
    "PRESENCIAL" = "1",
    "NAO_PRESENCIAL_INTERNET" = "2",
    "NAO_PRESENCIAL_TELEATENDIMENTO" = "3",
    "NFC_E_ENTREGA_DOMICILIO" = "4",
    "PRESENCIAL_FORA_ESTABELECIMENTO" = "5",
    "NAO_PRESENCIAL_OUTROS" = "9"
}